
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 10.938H.937a.938.938 0 00-.937.937v2.813c0 .517.42.937.938.937H3.75c.518 0 .938-.42.938-.938v-2.812a.938.938 0 00-.938-.938zm-.703-2.344h5.625V10h1.406V8.594h5.625V10h1.406V8.313c0-.62-.504-1.126-1.125-1.126h-5.906V5.313h1.172c.518 0 .938-.42.938-.937V1.562a.938.938 0 00-.938-.937H7.5a.938.938 0 00-.938.938v2.812c0 .518.42.938.938.938h1.172v1.875H2.766c-.62 0-1.125.504-1.125 1.125V10h1.406V8.594zm7.734 2.344H7.97a.938.938 0 00-.938.937v2.813c0 .517.42.937.938.937h2.812c.518 0 .938-.42.938-.938v-2.812a.938.938 0 00-.938-.938zm7.031 0H15a.938.938 0 00-.938.937v2.813c0 .517.42.937.938.937h2.813c.517 0 .937-.42.937-.938v-2.812a.938.938 0 00-.938-.938z","fill":"currentColor"}})])
          )
        }
      }
    